import godrejBgImage from '../../assets/ReferralForm/Godrej.png';

import { fabClasses, imageListClasses } from '@mui/material';

const ENV = window.reloy_env.ENV || process.env.REACT_APP_ENV;

const config = {
    clientId:
        '4757d92ecbc85bd93320870e1d15ae79788920c0cbf41abe884bfbc4980a0c08',
    id: 7,
    name: 'Godrej',
    fullName: 'Godrej Properties',
    programLogo:
        'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1722920175286_Placeholder',
    programName: 'Godrej Ambassador',
    theme: 'godrejTheme',
    favicon: 'https://cdn.loyalie.in/63578721.jpg',
    primaryColor: '#7f7065',
    fontBody: `font-Helvetica_Light`,
    fontTitle: `font-Helvetica_Medium`,
    googleConfig: {
        gID: 'G-8WGS6KG77E  ',
        keywordsContent: '',
        descriptionContent: '',
        authorContent: 'Godrej Ambassador'
    },

    facebookPixelConfig: {
        id: '1189595868577078',
        metaName: '',
        metaContent: ''
    },

    sectionBackground: {
        // image: godrejPattern,
        // color: '255,255,255',
        // opacity: '0.96',
        // size: '90%'
    },

    webengageLic: 'in~~10a5cbb09',
    WAK: '617f9e57-d325-4b8e-a937-033466c69b77',
    uatFacebookPixelConfig: {
        id: '',
        metaName: '',
        metaContent: ''
    },
    manuallySelectReward: true,
    IsEmployeeAndSalesAdmin: true,
    employeeRegistrationFormVisible: true,
    webview: { coloredTheme: false },
    logoLeft: {
        name: 'godrejLogo',
        url: 'https://www.godrejproperties.com/images/logo_godrej_properties.png',
        stickyNavBarLogoClass:
            'relative h-10 lg:h-10 xl:h-10  left-2 lg:left-8 ease-in duration-300',
        baseNavBarLogoClass:
            'relative h-10 lg:h-10 xl:h-12  left-2 lg:left-8 ease-out duration-300'
    },

    navBarConfig: {
        dropDown: true,
        font: `font-Helvetica_Medium`,
        height: 'h-16 lg:h-20 ease-out duration-300',
        stickyHeight: 'h-16 lg:h-18 ease-in duration-300 	',
        mobileIconColor: 'text-primary',
        dropDownBg: 'bg-white  ',
        showLogin: true,
        baseNavBar: {
            border: false,
            borderClass: '',
            backgroundColor: 'bg-primary-content drop-shadow-md ', // default: transparent
            containerClass: ' ',
            itemClass:
                'uppercase lg:mr-[10px] xl:mr-[20px] text-black lg:text-black hover:text-primary text-[14px] lg:text-[10px] xl:text-[13px] 2xl:text-[13px]',
            dropDownContainerClass: `text-black lg:text-black hover:text-primary focus:text-primary lg:focus:shadow-outline `,
            dropDownItemClass:
                'tracking-widest hover:text-primary text-[14px] lg:text-[11px] xl:text-[13px] 2xl:text-[13px]'
        },
        stickyNavBar: {
            border: true,
            borderClass: ' ',
            backgroundColor: 'bg-primary-content drop-shadow-md ', //default: primary-content,
            containerClass: ' ', //entire Nav Bar Class (add min-w-full for godrej navbar effect)
            itemClass:
                'uppercase lg:mr-[10px] xl:mr-[20px] text-black lg:text-black hover:text-primary text-[14px] lg:text-[10px] xl:text-[13px] 2xl:text-[13px]' // Each list element in NavBar (Text color, hover color, size)
        },
        showActiveLinkColor: false
    },
    floaterClass: 'hover:godrej-floater-hover',
    bannerNegativeTopMarginClass: ' ',
    scrollToTargetAdjustedValue: 60,
    clientButtonClassName: `godrej-button hover:godrej-button-hover text-sm font-Helvetica_Medium`,

    increasePageSize: true,
    showFooterRoutes: false,
    webviewRoutes: {
        home: {
            name: 'OVERVIEW',
            scrollTo: 'overview',
            path: '/',
            show: true
        },
        events: {
            name: 'CURATED EVENTS',
            path: '/events',
            component: 'Events',
            show: true
        },
        referSection: {
            show: true,
            name: 'REFER NOW',
            scrollTo: 'referral_section',
            path: '/',
            component: 'ReferAndEarn'
        }
    },
    webview: {
        textStyle: `font-Helvetica_Medium uppercase font-medium`,
        iconColor: `#7f7065`,
        initialsClass: 'text-primary'
    },
    routes: {
        home: {
            name: 'OVERVIEW',
            scrollTo: 'overview',
            path: '/',
            show: true,
            components: [
                {
                    type: 'BANNER_NEW',
                    backgroundImage: 'https://cdn.loyalie.in/44189520.jpg   ',
                    backgroundImageMobile:
                        'https://cdn.loyalie.in/46943476.jpg',
                    bannerContainerClass:
                        'hero max-w-full h-[70vh] lg:h-[75vh] 2xl:h-[85vh] bg-top lg:bg-left-top ',
                    bannerItemContainerClass: 'lg:pl-10', // bannerContainerClassName:
                    //     'hero hero-content max-w-full h-[60vh]  md:h-[85vh] lg:h-[89vh] xl:h-[75vh] 2xl:h-[80vh] bg-center lg:bg-top z-10 ',
                    linearGradient: {
                        R: '127',
                        G: '112',
                        B: '101',
                        opacity: '0.1'
                    },
                    components: [
                        {
                            type: 'TEXT',
                            content: 'WELCOME TO',
                            className: `mt-36 lg:mt-48 xl:mt-64 2xl:mt-60 3xl:mt-60 text-white text-center lg:text-left text-[12px] lg:text-[17px] xl:text-[20px] 2xl:text-[24px] tracking-widest font-Helvetica_Medium`
                        },

                        {
                            type: 'IMAGE',
                            url: 'https://cdn.loyalie.in/69005341.png',
                            className:
                                'mx-auto lg:mx-0 w-[75%] md:w-[35%] lg:w-[30%] xl:w-[30%] 2xl:w-[27%] mt-2'
                        },
                        {
                            type: 'TEXT',
                            content: 'It’s more than a home, it’s a lifestyle.',
                            className: `text-white text-center lg:text-left text-[15px] md:text-[16px] lg:text-[15px] xl:text-[19px] 2xl:text-[20px] leading-[20px] 2xl:leading-[22px] tracking-wide lg:tracking-widest lg:leading-snug mt-3 mb-6 break-words  font-Helvetica_Medium`
                        },
                        {
                            type: 'BUTTON',
                            content: 'REFER NOW',
                            className: `mx-auto lg:mx-0 text-sm godrej-button hover:godrej-button-hover xl:mb-10 font-Helvetica_Medium`,
                            path: 'gift-and-earn',
                            onClick: 'CHANGE_PATH_AND_SCROLL',
                            scrollTo: 'referral_section'
                        }
                    ]
                },
                {
                    type: 'CUSTOM',
                    id: 'overview',
                    className:
                        'flex flex-col justify-center text-center  overflow-hidden z-1',

                    components: [
                        {
                            type: 'CUSTOM',
                            className:
                                'w-[90%] xl:w-full mx-auto pt-8 lg:pt-12 xl:pt-16 pb-4 lg:pb-6 xl:pb-8 relative',
                            components: [
                                // {
                                //     type: 'IMAGE',
                                //     url: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/64420770.png',
                                //     classNameContainer:
                                //         ' absolute w-[27%] 2xl:w-[23%] -top-0  -left-44 2xl:-left-36  z-2 opacity-30'
                                // },
                                // {
                                //     type: 'IMAGE',
                                //     url: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/32160716.png',
                                //     position: 'center',
                                //     classNameContainer:
                                //         ' absolute w-[27%] 2xl:w-[23%] -right-44 2xl:-right-36 -bottom-0 z-2 opacity-30'
                                // },
                                {
                                    type: 'TEXT',
                                    content:
                                        'WELCOME TO THE GODREJ AMBASSADOR PROGRAM',

                                    className: `tracking-wide text-[17px] leading-[18px] lg:text-[18px] xl:text-[20px] 2xl:text-[22px] text-primary font-Helvetica_Medium`
                                },
                                {
                                    type: 'DIVIDER',
                                    className:
                                        'self-center m-auto w-[20%] lg:w-[10%] bg-primary border-none h-[4px]',
                                    classNameContainer: 'mt-3'
                                },
                                {
                                    type: 'TEXT',
                                    content:
                                        "Godrej Ambassador is an exclusive luxury membership program for homeowners at Godrej Properties. The program curates a lifestyle that goes beyond homeowning and enriches every facet of the member's life.",

                                    className: `text-secondary-focus text-[16px] xl:text-[16.5px] 2xl:text-[17px] mt-[20px] leading-[21px] lg:leading-[21px] xl:leading-[22px] 2xl:leading-[24px] mb-12 w-full md:w-[80%] lg:w-[90%] xl:w-[70%] 2xl:w-[60%]  mx-auto xl:mt-6 font-Helvetica_Light`
                                },
                                {
                                    type: 'TEXT',
                                    content: 'GET',
                                    className: `font-Helvetica_Medium inline-block text-primary text-[16px] xl:text-[16.5px] 2xl:text-[20px] leading-[18px] lg:leading-[20px] 2xl:leading-[22px]`
                                },
                                {
                                    type: 'TEXT',

                                    content: ' 1%',
                                    className: `inline-block text-transparent bg-clip-text bg-gradient-to-r from-[#B58A2F] via-[#F8E196] to-[#D0AB6E]  ml-1 text-xl 2xl:text-[25px] leading-[18px] lg:leading-[20px] 2xl:leading-[22px] font-Helvetica_Medium`
                                },
                                {
                                    type: 'TEXT',

                                    content: ' REWARD AND SHARE',
                                    className: `inline-block text-primary ml-1 text-[16px] xl:text-[16.5px] 2xl:text-[20px] leading-[18px] lg:leading-[20px] 2xl:leading-[22px] font-Helvetica_Medium `
                                },
                                {
                                    type: 'TEXT',

                                    content: ' 1%',
                                    className: `inline-block text-transparent bg-clip-text bg-gradient-to-r from-[#B58A2F] via-[#F8E196] to-[#D0AB6E]  ml-1 text-xl 2xl:text-[25px] leading-[18px] lg:leading-[20px] 2xl:leading-[22px] font-Helvetica_Medium `
                                },
                                {
                                    type: 'TEXT',
                                    content: ' DISCOUNT*',
                                    className: `inline-block text-primary ml-1 text-[16px] xl:text-[16.5px] 2xl:text-[20px] leading-[18px] lg:leading-[20px] 2xl:leading-[22px] font-Helvetica_Medium`
                                },
                                // {
                                //     type: 'TEXT',
                                //     content:
                                //         '*This referral benefit is applicable for a limited time period from 12th Dec’24 to 31st March’25',
                                //     className: `text-secondary-focus text-[16px] xl:text-[16.5px] 2xl:text-[15px] leading-[21px] lg:leading-[21px] xl:leading-[22px] 2xl:leading-[24px] mb-12 w-full md:w-[80%] lg:w-[90%] xl:w-[70%] 2xl:w-[60%]  mx-auto ${
                                //         getFont('GODREJ').body
                                //     }`
                                // },
                                {
                                    type: 'CUSTOM',
                                    className:
                                        'w-full md:w-[75%] lg:w-full 2xl:w-full mx-auto lg:mt-4 z-1',
                                    components: [
                                        {
                                            type: 'ICONS_LAYOUT',

                                            infotxtClassName:
                                                ' w-[90%] md:w-[50%] lg:w-[55%]  xl:w-[60%] 2xl:w-[75%]  mx-auto l 2xl:px-10 text-[16px] xl:text-[16.5px] 2xl:text-[17px] font-Helvetica_Light  text-black font-normal leading-[21px] lg:leading-[21px] xl:leading-[22px] 2xl:leading-[24px] ',
                                            info: [
                                                {
                                                    imgUrl: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/23965860.png',
                                                    infoText:
                                                        'Avail exclusive lifestyle offers & benefits'
                                                },
                                                {
                                                    imgUrl: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/63869318.png',
                                                    infoText:
                                                        'Enjoy select events and experiences'
                                                },
                                                {
                                                    imgUrl: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/53575022.png',
                                                    infoText:
                                                        'Experience trending lifestyle topics'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'CAROUSEL_NEW',
                            carouselHeight: 'h-auto lg:h-[75vh]',
                            headingClass: `tracking-wide text-[17px] leading-[18px] lg:text-[18px] xl:text-[20px] 2xl:text-[22px] text-white font-Helvetica_Medium`,
                            bodyClass: `text-white text-[16px] xl:text-[16.5px] 2xl:text-[17px] py-5 leading-[21px] lg:leading-[21px] xl:leading-[22px] 2xl:leading-[24px]  font-Helvetica_Light`,
                            buttonClass: `bg-white rounded-[30px] px-4 xl:px-[30px] py-2 xl:py-[12px] text-primary text-[13px] md:text-[14px] border-[1px] border-white hover:bg-primary hover:text-white font-semibold`,
                            imgClassName:
                                'w-full object-cover h-[600px] lg:h-full',
                            images: [
                                {
                                    imgUrl: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/53911735.jpg',
                                    bgColor: '#7f7065',
                                    txtOne: 'REFERRALS AND EARNINGS',
                                    txtTwo: 'Building a community needs trust. As part of Godrej Ambassador, you can share your lifestyle with friends and family and earn benefits for successfully referring them. With us, you can build a community surrounded by people you love, creating a neighborhood that you feel connected to.',
                                    buttonText: 'REFER NOW',
                                    // MODIFY: REFER PAGE
                                    path: '/gift-and-earn'
                                    // scrollTo: 'referral_section'
                                },
                                {
                                    imgUrl: 'https://cdn.loyalie.in/13648823.jpg',
                                    bgColor: '#7f7065',
                                    txtOne: 'OFFERS AND PROMOTIONS',
                                    txtTwo: 'At Godrej Ambassador, we are all about creating value-added experiences that add more to your lifestyle. We give you access to premium and pan-india brands that elevate your lifestyle above the ordinary. Our goal is to curate the best experiences and bring them to you.',
                                    buttonText: 'AVAIL NOW',
                                    path: '/deals'
                                },
                                {
                                    imgUrl: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/47378636.jpg',
                                    bgColor: '#7f7065',
                                    txtOne: 'WORKSHOPS AND EVENTS',
                                    txtTwo: 'Everyone needs a break from the monotony of life. Our workshops and events are designed to create engaging experiences with top collaborators, experts, and content creators.',
                                    buttonText: 'PARTICIPATE NOW',
                                    path: '/events'
                                },
                                {
                                    imgUrl: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/69026160.jpg',
                                    bgColor: '#7f7065',
                                    txtOne: 'INTERACTIVE BLOGS',
                                    txtTwo: 'Reading adds more to what we know and how we perceive the world. As part of the Godrej Ambassador experience, we bring you bite-sized infotainment to keep adding to the things you know.',
                                    buttonText: 'READ NOW',
                                    path: '/blogs'
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'CUSTOM',
                    className:
                        'xl:w-full w-full xl:flex xl:h-auto bg-white items-center',

                    components: [
                        {
                            type: 'CUSTOM',
                            className:
                                ' w-full h-auto  flex flex-col justify-center text-center py-10 px-2 lg:px-8 xl:px-12',
                            components: [
                                {
                                    type: 'TEXT',
                                    content:
                                        'START BUILDING YOUR COMMUNITY NOW',
                                    className: `text-secondary leading-[19px] xl:leading-[20px] 2xl:leading-[22px] text-[17px] lg:text-[18px] xl:text-[20px] 2xl:text-[22px] font-Helvetica_Medium`
                                },
                                {
                                    type: 'TEXT',
                                    content:
                                        'The best communities are built on trust and care for one another. Godrej Ambassador offers you the opportunity to refer your loved ones and help them become a part of a community that goes beyond sharing a neighbourhood.',

                                    className: `text-secondary-focus xl:px-4 mx-auto leading-[21px] lg:leading-[21px] xl:leading-[22px] 2xl:leading-[24px] text-[16px] xl:text-[16.5px] 2xl:text-[17px] xl:w-[90%] 2xl:w-[75%] mt-4 font-Helvetica_Light`
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'REFERRAL_FORM_BANNER'
                },
                {
                    type: 'CUSTOM',
                    className: 'mt-14 mb-10',
                    components: [
                        {
                            type: 'TEXT',
                            content: 'MAKE IT WORK FOR YOU',
                            className: `text-center  text-secondary tracking-wide text-[17px] lg:text-[18px] xl:text-[20px] 2xl:text-[22px] font-Helvetica_Medium`
                        },

                        {
                            type: 'ICONS_LAYOUT',
                            containerClassName:
                                'h-content lg:h-auto bg-white items-center pt-3 xl:pt-5 ',
                            gridClassName:
                                'flex lg:grid lg:grid-cols-2 w-full lg:w-[80%] m-auto overflow-x-scroll lg:overflow-x-hidden',

                            infoHeadingClassName: `w-full mx-auto leading-6 xl:leading-[27px] md:px-2 text-[20px] md:text-[22px] xl:text-xl  text-primary font-semibold pt-4 pb-2 tracking-wider font-Helvetica_Medium`,
                            infotxtClassName:
                                ' w-[90%] md:w-[50%] lg:w-[85%] xl:w-[70%] 2xl:w-[75%]  mx-auto l 2xl:px-10 text-[16px] xl:text-[16.5px] 2xl:text-[17px] font-Helvetica_Light  text-black font-normal leading-[21px] lg:leading-[21px] xl:leading-[22px] 2xl:leading-[24px] ',
                            infoContainerClassName:
                                'min-w-[80vw] lg:min-w-full mt-4 lg:mt-0',
                            imgContainerClassName: '',
                            imgClassName:
                                'w-[16%] md:w-[8%] lg:w-[13%] lg:mx-auto mx-auto lg:mb-2',
                            info: [
                                {
                                    imgUrl: 'https://cdn.loyalie.in/27025232.png',
                                    infoHeading: 'STEP 1',
                                    infoText:
                                        'We connect with your references and introduce them to Godrej Ambassador.'
                                },
                                {
                                    imgUrl: 'https://cdn.loyalie.in/86958134.png',
                                    infoHeading: 'STEP 2',
                                    infoText:
                                        'Once they book a home with Godrej Properties, you begin enjoying the rewards.'
                                }
                                // {
                                //     imgUrl: 'https://cdn.loyalie.in/639615.png',
                                //     infoHeading: 'STEP 3',
                                //     infoText:
                                //         "Get privileged access to content that's crafted to your interests and preferences, and interact with people of similar tastes."
                                // }
                            ]
                        }
                    ]
                },

                {
                    type: 'CUSTOM',
                    url: '',
                    id: 'about',
                    className:
                        'hide h-content xl:w-full w-full lg:flex xl:h-auto bg-white items-center border-t-[3px] border-b-[3px] border-[#7f7065]',
                    components: [
                        {
                            type: 'CUSTOM',
                            url: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/43765574.png',
                            linearGradient: {
                                R: '255',
                                G: '255',
                                B: '255',
                                opacity: '0.7',
                                size: '500%',
                                position: 'center'
                            },

                            className:
                                ' w-[10%] lg:h-[500px] xl:h-[695px] 2xl:h-[748px]'
                        },

                        {
                            type: 'CUSTOM',
                            className:
                                '  w-full lg:w-[65%] text-[#7f7065] px-8 py-10  xl:px-10 xl:py-10   ',

                            components: [
                                {
                                    type: 'TEXT',
                                    content:
                                        'KNOW MORE ABOUT GODREJ PROPERTIES',
                                    className: `text-secondary tracking-wide text-[17px] lg:text-[18px] xl:text-[20px] 2xl:text-[22px] font-Helvetica_Medium`
                                },
                                {
                                    type: 'DIVIDER',
                                    className:
                                        'w-[25%] md:w-[16%] xl:w-[14%] bg-accent border-none h-[4px]',
                                    classNameContainer: 'mt-2'
                                },
                                {
                                    type: 'TEXT',
                                    content:
                                        "Godrej Properties brings the Godrej Group philosophy of innovation, sustainability, and excellence to the real estate industry. Each Godrej Properties development combines a 125–year legacy of excellence and trust with a commitment to cutting-edge design and technology. In recent years, Godrej Properties has received over 250 awards and recognitions, including ‘The Most Trusted Real Estate Brand’ in 2019 from the Brand Trust Report, 'Real Estate Company of the Year' at the 9th Construction Week Awards 2019, ‘Equality and Diversity Champion’ 2019 at the APREA Property Leaders Awards, ‘The Economic Times Best Real Estate Brand 2018’ and the ‘Builder of the Year’ at the CNBC-Awaaz Real Estate Awards 2018.  In 2016, we stood 2nd in Asia and 5th in the world in the GRESB (Global Real Estate Sustainability Benchmarking) study, which is an industry led sustainability and governance benchmarking platform.",

                                    className: `text-secondary-focus xl:pr-5 2xl:pr-8 3xl:pr-48 py-5 text-[15.5px] xl:text-[16.5px] 2xl:text-[17px] leading-[21px] lg:leading-[21px] xl:leading-[22px] 2xl:leading-[24px] font-Helvetica_Light`
                                }
                                // {
                                //     type: 'TEXT',
                                //     content:
                                //         "Our projects over the years have delivered many firsts in the Indian real estate market. Planet Godrej, a skyscraper in Mumbai, was India's tallest occupied building when completed in 2008. It also illustrated our focus on customer safety and wellbeing by becoming the first project in the country to offer residents a fire escape chute. Our commercial office project, Godrej BKC, is the only LEED (Leadership in Energy and Environmental Design) Platinum rated building in India's leading commercial district, Bandra Kurla Complex, demonstrating Godrej Properties' commitment to environmental sustainability. It is also the project where we broke the record for India's highest ever commercial end-user sales transaction when a large multinational pharmaceutical company purchased space in this project for INR 1,479 crore in 2015. Our flagship project, The Trees, is one of India's most sustainably planned mixed-use projects that we hope will contribute to the evolution of urban design thinking in the country. We sold over INR 1,200 crore worth of space within six months of launching this project in 2015, making it one of the country's most successful residential project launches.",

                                //     className: `text-secondary-focus xl:pr-5 2xl:pr-8  3xl:pr-48 pb-5 pt-4 text-[15.5px] xl:text-[16.5px] 2xl:text-[17px] leading-[19px] xl:leading-[20px] 2xl:leading-[22px] font-Helvetica_Light`
                                // },
                                // {
                                //     type: 'TEXT',
                                //     content:
                                //         "With an estimated 10 million Indians moving into the urban areas annually, the country's urban landscape is likely to change dramatically in the coming decades. We firmly believe that India must seize on the opportunity to urbanize in a sustainable manner. Our group has always been at the forefront of the environmental sustainability movement. The CII-Godrej Green Building Center in Hyderabad, when it was completed in 2004, was the first LEED Platinum building outside of the United States and was the single highest rated LEED building in the world.  In 2010, Godrej Properties committed that every single project we develop will be a certified green building. Many of our projects have since received LEED Platinum certifications, which are globally recognized as the leading sustainability recognitions. Our large township project, Godrej Garden City, in Ahmedabad was selected as one of only 2 projects in India and 16 worldwide by The Clinton Foundation to partner with them in the goal of achieving a climate positive development. In 2016, we stood 2nd in Asia and 5th in the world in the GRESB (Global Real Estate Sustainability Benchmarking) study, which is an industry led sustainability and governance benchmarking platform. ",

                                //     className: `text-secondary-focus xl:pr-5 2xl:pr-8  3xl:pr-48 pb-5 pt-4 text-[15.5px] xl:text-[16.5px] 2xl:text-[17px] leading-[19px] xl:leading-[20px] 2xl:leading-[22px] font-Helvetica_Light`
                                // }
                            ]
                        },
                        {
                            type: 'IMAGE',
                            url: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/10983397.jpg',
                            position: 'center',
                            classNameContainer:
                                'lg:w-[35%] w-[100%] flex lg:gap-0 gap-0'
                        }
                    ]
                },

                {
                    type: 'CUSTOM',
                    className:
                        'text-center w-[100%] text-[#7f7065]  xl:py-10 py-10',
                    components: [
                        {
                            type: 'TEXT',
                            content: 'GODREJ PROPERTIES LATEST BLOGS',
                            className: `text-secondary tracking-wide px-6 leading-[20px] xl:leading-[20px] 2xl:leading-[22px] lg:px-0 text-[17px] lg:text-[18px] xl:text-[20px] 2xl:text-[22px] font-Helvetica_Medium`
                        },
                        {
                            type: 'DIVIDER',
                            className:
                                'self-center m-auto w-[20%] xl:w-[10%] bg-accent  border-none h-[3px] xl:h-[4px]',
                            classNameContainer: 'mt-3'
                        }
                    ]
                },
                {
                    type: 'BLOG_LAYOUT_VERTICAL1',
                    // url: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/42577492.png',
                    // linearGradient: {
                    //     R: '255',
                    //     G: '255',
                    //     B: '255',
                    //     opacity: '0.95',
                    //     size: '60%'
                    // },
                    className:
                        'w-full flex flex-col-reverse lg:flex-row h-auto relative mx-auto justify-center'
                    // // API: 'https://godrejambassador.reloy.co/wp-json/wp/v2/posts',
                    // headingClass: `text-[18px] xl:text-[20px] 2xl:text-[22px] leading-[19px] xl:leading-[21px] 2xl:leading-[22px]  uppercase tracking-wide text-primary px-4 md:px-12 py-4 md:py-7 lg:px-10 lg:py-4 font-Helvetica_Medium`,
                    // bodyClass: `text-secondary-focus px-4 md:px-12 lg:px-10 text-[16px]  xl:text-[16.5px] 2xl:text-[17px] leading-[18px]  xl:leading-[19px] 2xl:leading-[22px] font-Helvetica_Light`,
                    // buttonClass: ` text-[16px] 2xl:text-[17px] px-4 md:px-12 py-4 md:py-7 lg:px-10 lg:pt-3 text-primary font-Helvetica_Medium`
                },
                {
                    type: 'CUSTOM',
                    className:
                        'xl:text-center text-center xl:w-full w-[100%] text-white  xl:pb-5  pb-10',
                    components: [
                        {
                            type: 'BUTTON',
                            content: 'LOAD MORE',
                            fontFamily: 'Helvetica_Medium',
                            path: 'blogs',
                            onClick: 'CHANGE_PATH'
                        }
                    ]
                },
                {
                    type: 'CUSTOM',
                    className:
                        'hide xl:text-center text-center xl:w-full w-[100%] text-[#7f7065]  xl:py-10  py-10',

                    id: 'godrej_projects_locations',
                    components: [
                        {
                            type: 'TEXT',
                            content: 'OUR PROJECT LOCATIONS',
                            className: `text-secondary tracking-wide text-[18px] xl:text-[20px] 2xl:text-[22px] font-Helvetica_Medium`
                        },
                        {
                            type: 'DIVIDER',
                            className:
                                'self-center m-auto  w-[25%] md:w-[16%] lg:w-[10%]  bg-accent  border-none h-[4px]',
                            classNameContainer: 'mt-2'
                        },
                        {
                            type: 'IMAGE_SECTION',
                            className:
                                'flex overflow-x-scroll lg:overflow-x-hidden lg:grid md:grid-flow-col hover:text-primary md:auto-cols-fr w-[90%] md:w-[60%] lg:w-[90%] xl:w-[80%] m-auto h-content text-black',
                            photosection: 'mt-7 min-w-[50vw] lg:min-w-full',
                            imgClassName:
                                'px-0  lg:px-4 text-center m-auto w-[50%] lg:w-[70%]',

                            imgArr: [
                                {
                                    imgSrc: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/26171152.jpg',
                                    text: 'Mumbai',

                                    link: 'https://www.godrejproperties.com/bycity/index/mumbai'
                                },
                                {
                                    imgSrc: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/16685822.jpg',
                                    text: 'Pune',

                                    link: 'https://www.godrejproperties.com/bycity/index/pune'
                                },
                                {
                                    imgSrc: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/7024385.jpg',
                                    text: 'Bangalore',

                                    link: 'https://www.godrejproperties.com/bycity/index/bangalore'
                                },
                                {
                                    imgSrc: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/17850835.jpg',
                                    text: 'Delhi NCR',

                                    link: 'https://www.godrejproperties.com/bycity/index/ncr'
                                },
                                {
                                    imgSrc: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/83359253.jpg',
                                    text: 'Kolkata',
                                    link: 'https://www.godrejproperties.com/bycity/index/kolkata'
                                },
                                {
                                    imgSrc: 'https://godrejprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Godrej/Images/22896570.jpg',
                                    text: 'Ahmedabad',
                                    link: 'https://www.godrejproperties.com/bycity/index/ahmedabad'
                                },
                                {
                                    imgSrc: 'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1747748497004_HYDERABAD',
                                    text: 'Hyderabad',
                                    link: 'https://www.godrejproperties.com/flats-in-hyderabad'
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    referPage: {
        banner: {
            loginBannerComponents: [
                // {
                //     type: 'HORIZONTAL_CAROUSEL',
                //     duration: 2500,
                //     arrows: false,
                //     imageFit: 'object-contain',
                //     imgHeight:
                //         'h-[70vh] md:h-[100vh] lg:h-[70vh] xl:h-[90vh] 2xl:h-[90vh]',
                //     images: [
                //         {
                //             imgUrl: 'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1721729871747_refer banner 2 lg',
                //             imgPosition: 'object-center',
                //             mobileImgUrl:
                //                 'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1721729883634_refer banner 2 sm',
                //             mobileImgPosition: 'object-center',
                //             onClick: 'OPEN_LOGIN',
                //                             //         }
                //     ]
                // },
                {
                    type: 'BANNER',
                    linearGradient: {
                        R: '0',
                        G: '0',
                        B: '0',
                        opacity: '0'
                    },
                    backgroundImage:
                        'https://cdn.loyalie.in/1692637968652_refer%20page',
                    backgroundImageMobile:
                        'https://cdn.loyalie.in/1692637968652_refer%20page',
                    bannerContainerClassName:
                        'relative hero hero-content max-w-full h-[60vh] object-cover bg-center lg:bg-left',
                    components: [
                        {
                            type: 'TEXT',
                            content:
                                'Refer your loved ones and get rewards on every successful referral',
                            className: `text-black text-[19px] md:text-[20px] xl:text-[25px] text-center lg:text-left uppercase  tracking-wide  lg:w-[50%] ml-auto lg:leading-8 font-Helvetica_Medium`
                        },
                        {
                            type: 'CUSTOM',
                            className: 'flex lg:w-[50%] ml-auto',
                            components: [
                                {
                                    type: 'BUTTON',
                                    content: 'Start Referring Now',
                                    onClick: 'OPEN_LOGIN',
                                    className: `godrej-button hover:godrej-button-hover text-sm mt-3 mx-auto lg:mx-0 font-Helvetica_Medium`
                                }
                            ]
                        }
                    ]
                }
            ]
        },

        components: [],

        customize: {
            deactivateProjectClick: true
        }
    },
    blogs: {
        linearGradient: {
            R: '255',
            G: '255',
            B: '255',
            opacity: '0.96',
            size: '30% auto'
        },
        banner: {
            bannerContainerClassName:
                'hidden md:hero hero-content max-w-full h-[400px]  md:bg-top mx-auto text-center ',
            linearGradient: {
                string: '100,65,43,0.7',
                R: '255',
                G: '255',
                B: '255',
                opacity: '0.20'
            },
            backgroundImage:
                'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1701334178809_bbanner',
            backgroundImageMobile:
                'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1701334178809_bbanner',

            components: [
                {
                    type: 'TEXT',
                    content: 'GODREJ AMBASSADOR READERS’ CLUB:',
                    className: ` text-[28px] md:text-[40px] lg:text-[30px] xl:text-[35px]  tracking-wider font-Helvetica_Medium`
                },
                // {
                //     type: 'DIVIDER',
                //     className:
                //         'mt-1 self-center mx-auto w-[40%] lg:w-[15%] bg-primary border-none h-[4px]',
                //     classNameContainer: ''
                // },
                {
                    type: 'TEXT',
                    content: 'Discover the latest home & lifestyle trends',
                    className: `font-medium text-[20px] 2xl:text-[22px] leading-6 mb-3 font-Helvetica_Medium`
                },
                {
                    type: 'BUTTON',
                    content: 'Read Now',
                    scrollTo: 'blogs_section',
                    onClick: 'SCROLL'
                }
            ],
            loginBannerComponents: [
                {
                    type: 'TEXT',
                    content: 'GODREJ AMBASSADOR READERS’ CLUB:',
                    className: ` text-[28px] md:text-[40px] lg:text-[30px] xl:text-[35px]   tracking-wider font-Helvetica_Medium`
                },
                // {
                //     type: 'DIVIDER',
                //     className:
                //         'mt-1 self-center mx-auto w-[40%] lg:w-[15%] bg-primary border-none h-[4px]',
                //     classNameContainer: ''
                // },
                {
                    type: 'TEXT',
                    content: 'Discover the latest home & lifestyle trends',
                    className: ` font-medium text-[20px] 2xl:text-[22px] leading-6 mb-3 font-Helvetica_Medium`
                },
                {
                    type: 'BUTTON',
                    content: 'Login To Read Now',
                    onClick: 'OPEN_LOGIN'
                }
            ]
        },
        comments: {
            commentButtonClass: '',
            initialsClass: ' '
        },
        primaryColor: '',
        fontHeading: `font-Helvetica_Medium`,
        fontBody: `font-Helvetica_Light`,
        button: {
            position: 'self-start',
            bgColor: true,
            border: false
        },
        sliderBanner: {
            featuredPost: {
                featuredPostClass: ` `,
                headingClass: `text-[30px] uppercase font-semibold text-primary mt-3 leading-9 break-words `,
                summaryClass: ` font-Helvetica_Medium`
            },
            sectionHeadings: `text-[22px] lg:text-[25px] xl:text-[35px] tracking-wider`
        },
        layout5: {
            headingClass: `!text-primary text-[21px] 3xl:text-[20px] !font-semibold`,
            summaryClass: `text-[16.5px] lg:text-[17px] !text-primary`,
            categoryClass: '!bg-[#00000075] !text-[11px]',
            buttonClass: `rounded-md`,
            dateClass: `text-[14px] lg:text-[15px] xl:text-[14px] 2xl:text-[15px] text-[#919396] font-Helvetica_Medium`
        }

        // {
        //     type: 'IFRAME',
        //     id: 'Iframe',
        //     url: 'https://godrejambassador.reloy.co',
        //     height: '100%',
        //     width: '100%',
        //     className:
        //         'h-[100vh] scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-400 '
        // }
    },

    events: {
        banner: {
            linearGradient: {
                R: '0',
                G: '0',
                B: '0',
                opacity: '0.2'
            },
            containerClass: 'hero self-center my-auto h-full text-white',
            heading: 'Events Archive',
            headingClass: `text-white mt-10 mb-5 text-2xl md:text-[35px] uppercase tracking-widest font-Helvetica_Medium`,
            subHeadingClass: `text-white uppercase font-semibold text-[28px] md:text-[33px] font-Helvetica_Medium`,

            negativeMargin: '-mt-16 2xl:-mt-16'
        },
        loginBanner: {
            bannerContainerClassName:
                'mt-16 2xl:mt-16 hero hero-content lg:bg-right bg-cover max-w-full h-[55vh] md:h-[70vh] lg:h-[90vh] mx-auto text-center ',
            components: [
                // {
                //     type: 'TEXT',
                //     content: 'CURATED WORKSHOPS AND EVENTS',
                //     className: ` mb-3 text-secondary text-[28px] md:text-[40px] lg:text-[30px] xl:text-[35px]  text-secondary tracking-wider font-Helvetica_Medium`
                // },
                // {
                //     type: 'DIVIDER',
                //     className:
                //         'mt-1 self-center mx-auto w-[40%] lg:w-[15%] bg-primary border-none h-[4px]',
                //     classNameContainer: ''
                // },
                // {
                //     type: 'TEXT',
                //     content:
                //         'Meet and connect with like-minded people of your bespoke community',
                //     className: `mt-5 text-secondary font-medium text-[20px] 2xl:text-[22px] leading-[22px] font-Helvetica_Medium`
                // },
                // {
                //     type: 'BUTTON',
                //     content: 'Login To Participate Now',
                //                     //     onClick: 'OPEN_LOGIN',
                //     className: ` lg:mx-0 mx-auto text-center lg:text-left mt-6  text-[15px] md:text-[17px] 2xl:text-[22px] tracking-wider bg-primary text-white rounded-[5px] py-3 md:py-2 2xl:py-[11px] px-5 md:px-6 font-Helvetica_Light`
                // }
            ]
        },
        fontHeading: `font-Helvetica_Medium`,
        fontBody: `font-Helvetica_Light`,
        eventsSection: {
            linearGradient: {
                R: '255',
                G: '255',
                B: '255',
                opacity: '0.96' //no gradient
            },

            headingClass: `text-[30px] text-2xl mt-14 text-primary border-b-2 border-[#373737] pb-2`,
            filterHeadingClass: `!text-[22px] mt-8 text-primary`
        },
        eventLayout: {
            titleClass: `text-secondary`
        }
    },

    deals: {
        disableBundleDeals: true,
        rewardsBanner: {
            backgroundImage:
                'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1727098879449_reward banner web',
            backgroundImageMobile:
                'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1727098879449_reward banner web'
        },
        dealsSection: {
            additionalTextClass: `z-10 text-2xl xl:text-[22px] text-primary uppercase  font-Helvetica_Medium `,
            subAdditionalTextClass: `z-10 capitalize text-secondary-focus font-Helvetica_Light`,
            noDealsClass: `z-10 text-secondary-focus text-xl text-center my-6
             font-Helvetica_Light`
        },
        dealLayout: {
            listTitleClass: `text-2xl lg:text-xl leading-[20px] 2xl:leading-[22px] text-primary font-Helvetica_Medium`,
            listBodyClass: `font-Helvetica_Light`,
            titleClassName: `text-primary  uppercase text-2xl xl:text-3xl mt-3 font-Helvetica_Medium `,
            termsAndConditionsClassName: `text-[#292929] font-extrabold capitalize text-[12px] self-center font-Helvetica_Light`,
            redeemNowButtonConfig: {
                type: 'BUTTON',
                content: 'Redeem Now',

                className: `godrej-button hover:godrej-button-hover rounded-3xl px-6 xl:px-9 py-3 text-[14px] self-center  uppercase  font-Helvetica_Medium `
            }
        }
    },
    projects: {
        // components: [
        //     {
        //         type: 'BANNER',
        //         backgroundImage: '',
        //         linearGradient: {
        //             R: '255',
        //             G: '255',
        //             B: '255',
        //             opacity: '0'
        //         },
        //         components: [
        //             {
        //                 type: 'TEXT',
        //                 content: 'GODREJ PROJECTS',
        //                 className: `mt-10 font-semibold text-2xl md:text-4xl text-white tracking-widest font-Helvetica_Medium`
        //             }
        //         ]
        //     }
        // ]
        moduleConfig: {
            hideProjects: false
        }
    },
    // header: {
    //     headerClass: 'hidden lg:block h-24 bg-black'
    // },

    termsAndConditions: {
        fontHeading: `font-Helvetica_Medium`,
        fontBody: `font-Helvetica_Light`,
        terms: [
            '“Referrer” shall mean either of (i) an existing eligible customer having booked a unit in a Godrej Properties project, and has entered into a registered Agreement to Sell; or (ii) employee of Godrej Properties; or (iii) a visit done not booked person/client (VDNB); or (iv) influencers; and wishes to introduce/refer another person(s) to book a unit in any of the eligible registered real estate project/s to be developed by Godrej Properties or any of its sister concerns/subsidiaries/affiliates (“Godrej Properties Project/s”). ‘Referred’ shall mean the eligible person introduced/referred to by the Referrer and who intends to book one or more units in any of the eligible registered real estate Godrej Properties Project/s and registers an agreement for sale for such unit(s).',
            'Referrer participation in the Referral Reward Program shall be subject to his/her/them producing a copy of a valid and subsisting registered Agreement to Sell executed in his/her/their favor by Godrej Properties.',
            'Referrer shall not be able to refer existing customer(s) of Godrej Properties. Referrer shall not be able to refer customer(s) who has/have in the last three months: (i) either made enquires (in any form, whether by way of site visit or otherwise with Godrej Properties or (ii) is/are already registered with Godrej Properties as a ‘Direct/Walk-in Customer’ or (iii) has/have come through any of the Godrej Properties’s Channel Partner or any other source. Assigning Referral Reward and determining eligibility as to who qualifies as ‘Referrer’ and ‘Referred’ will be at sole discretion of Reloy and the same shall not be challenged/contested by the Referrer and/or the Referred at any point of time.',
            'In the event that a referral is submitted twice from different Referrers, then the first referral received will be eligible for the Reward (subject to other applicable terms herein) and shall not be disputed by the other Referrers.',
            'Referrals are not valid where the Referrer and the Referred party are one and the same person.',
            'Referrals will be valid for three months from the date a person/party is ‘Referred’ unless such person/party has paid any booking amount to Godrej Properties within the said period of three months.',
            'By accepting our terms and conditions, both Referrer and Referred represent that they have the authority to disclose the name and details of the person or business to Godrej Properties.',
            'Subject to the terms mentioned herein, the reward will be paid to the Referrer within 90 (ninety) days from the date of registration of the agreement for sale by the Referred party. The reward will be in the form of gift vouchers/cards having value and a validity period with applicable terms and conditions.',
            'This Referral Reward Program cannot be clubbed with any other offer /scheme, whether run by Godrej Properties or otherwise.',
            'Customers who are employees of working either in marketing, sales or CRM departments/team and employees of Reloy will not be eligible for participating in this Referral Reward Program and accordingly shall not be entitled for any reward.',
            'Reloy will not be liable for any unforeseen delay/deficiency/defect in any product or services disbursed as rewards by it or on account of any dispute relating to right to utilize the product or services subsequent to disbursement of the same.',
            'The terms and conditions of this program are subject to change at any time. Reloy will intimate the same to the Referrer. This program may be terminated at the discretion of Reloy.',
            'All disputes shall be subject to exclusive jurisdiction of Mumbai courts.'
        ],
        components: [
            {
                type: 'CUSTOM',
                className: 'text-left w-full ',

                components: [
                    //     points: [
                    //         '“Referrer” shall mean either of (i) an existing eligible customer having booked a unit in a Godrej Properties project, and has entered into a registered Agreement to Sell; or (ii) employee of Godrej Properties; or (iii) a visit done not booked person/client (VDNB); or (iv) influencers; and wishes to introduce/refer another person(s) to book a unit in any of the eligible registered real estate project/s to be developed by Godrej Properties or any of its sister concerns/subsidiaries/affiliates (“Godrej Properties Project/s”). ‘Referred’ shall mean the eligible person introduced/referred to by the Referrer and who intends to book one or more units in any of the eligible registered real estate Godrej Properties Project/s and registers an agreement for sale for such unit(s).',
                    //         'Referrer participation in the Referral Reward Program shall be subject to his/her/them producing a copy of a valid and subsisting registered Agreement to Sell executed in his/her/their favor by Godrej Properties.',
                    //         'Referrer shall not be able to refer existing customer(s) of Godrej Properties. Referrer shall not be able to refer customer(s) who has/have in the last three months: (i) either made enquires (in any form, whether by way of site visit or otherwise with Godrej Properties or (ii) is/are already registered with Godrej Properties as a ‘Direct/Walk-in Customer’ or (iii) has/have come through any of the Godrej Properties’s Channel Partner or any other source. Assigning Referral Reward and determining eligibility as to who qualifies as ‘Referrer’ and ‘Referred’ will be at sole discretion of Reloy and the same shall not be challenged/contested by the Referrer and/or the Referred at any point of time.',
                    //         'In the event that a referral is submitted twice from different Referrers, then the first referral received will be eligible for the Reward (subject to other applicable terms herein) and shall not be disputed by the other Referrers.',
                    //         'Referrals are not valid where the Referrer and the Referred party are one and the same person.',
                    //         'Referrals will be valid for three months from the date a person/party is ‘Referred’ unless such person/party has paid any booking amount to Godrej Properties within the said period of three months.',
                    //         'By accepting our terms and conditions, both Referrer and Referred represent that they have the authority to disclose the name and details of the person or business to Godrej Properties.',
                    //         'Subject to the terms mentioned herein, the reward will be paid to the Referrer within 90 (ninety) days from the date of registration of the agreement for sale by the Referred party. The reward will be in the form of gift vouchers/cards having value and a validity period with applicable terms and conditions.',
                    //         'This Referral Reward Program cannot be clubbed with any other offer /scheme, whether run by Godrej Properties or otherwise.',
                    //         'Customers who are employees of working either in marketing, sales or CRM departments/team and employees of Reloy will not be eligible for participating in this Referral Reward Program and accordingly shall not be entitled for any reward.',
                    //         'Reloy will not be liable for any unforeseen delay/deficiency/defect in any product or services disbursed as rewards by it or on account of any dispute relating to right to utilize the product or services subsequent to disbursement of the same.',
                    //         'The terms and conditions of this program are subject to change at any time. Reloy will intimate the same to the Referrer. This program may be terminated at the discretion of Reloy.',
                    //         'All disputes shall be subject to exclusive jurisdiction of Mumbai courts.'
                    //     ],
                    //     classNameContainer: 'px-16 mt-6'
                    // },

                    {
                        type: 'CUSTOM',
                        className: 'text-left w-full  py-4 ',
                        components: [
                            {
                                type: 'TEXT',
                                content:
                                    'Terms and Conditions for Employee Referral Program – Godrej Properties Limited (GPL)',
                                className: `mt-7 tracking-wide text-black text-[17px] font-Helvetica_Medium`
                            },

                            {
                                type: 'LIST',
                                listStyle: 'list-decimal',
                                points: [
                                    'GIG employees can successfully refer 3 times in a FY',
                                    'The cumulative benefit for an employee in FY is capped at ₹1.05 lakhs',
                                    'All GIG employees who are not on probation or notice period will be eligible for referral benefit on successful referral',
                                    'The voucher will be given within 60 days of 10% collection completion and deal approved status in the system',
                                    'The company has a Lead Protection Policy of 60 days, under which if the lead (reference shared by GIG employee) is tagged to any source, it shall be attributed to that source for a duration of 60 days.',
                                    'In case the lead shared by the employee is already assigned to other source and is within the 60 days Lead Protection Policy, the L&R team will inform the employee accordingly and no referral benefit (voucher) will be given.',
                                    'If an employee comes to us post booking done by his friend/neighbour/relative/acquaintance no referral benefit (voucher) will be given.'
                                ],
                                classNameContainer: ' mt-2'
                            },
                            {
                                type: 'CUSTOM',
                                className: 'z-10 ml-1',
                                components: [
                                    {
                                        type: 'TEXT',
                                        content:
                                            '8. Apart from all the mentioned eligibility criteria in this SOP, the employee will only be eligible for referral benefit (voucher) if the referral enquiry is shared on the Godrej Ambassador website ',

                                        className: `font-Helvetica_Light inline text-black text-[17px] leading-[22px] `
                                    },
                                    {
                                        type: 'LINK',
                                        url: 'https://www.godrejambassador.com/godrej-website/gift-and-earn',
                                        content:
                                            'https://www.godrejambassador.com/godrej-website/gift-and-earn',
                                        className: `inline ml-1 text-primary text-[16px] xl:text-[16.5px] 2xl:text-[17px] leading-[19px] xl:leading-[20px] 2xl:leading-[22px] font-Helvetica_Light`
                                    }
                                ]
                            },

                            {
                                type: 'CUSTOM',
                                className: 'z-10',
                                components: [
                                    {
                                        type: 'TEXT',
                                        content:
                                            '9. The following GPL personnels will not be eligible for any employee referral benefit',

                                        className: `font-Helvetica_Light inline text-black text-[17px] leading-[22px] `
                                    },
                                    {
                                        type: 'LIST',
                                        listStyle: 'list-disc',

                                        points: [
                                            'Entire Management Committee (MCs)',
                                            'Entire ZEC of the zone in which the project falls along with PD/Cluster PD of that project. E.g.: For project X in Mumbai Zone, the entire Mumbai ZEC and the PD/Cluster PD for that project will not be eligible for any employee referral benefit',
                                            'GPL Sales, Marketing & CC teams'
                                        ],
                                        classNameContainer: 'pl-10 !mt-0'
                                    }
                                ]
                            },
                            {
                                type: 'CUSTOM',
                                className: 'z-10',
                                components: [
                                    {
                                        type: 'TEXT',
                                        content:
                                            '10. 1.5% referral benefit is valid for a duration of 12th December 2024 to 31st March 2025.',

                                        className: `font-Helvetica_Light inline text-black text-[17px] leading-[22px] `
                                    }
                                ]
                            },
                            {
                                type: 'CUSTOM',
                                className: 'z-10 mt-3',
                                components: [
                                    {
                                        type: 'LINK',
                                        url: 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Godrej/T%26Cs/Marriott+Hotels+T%26Cs.pdf',
                                        content:
                                            'Marriott E-voucher Terms and Conditions,',
                                        className: `inline-block lg:inline ml-1 text-primary text-[16px] xl:text-[16.5px] 2xl:text-[17px] leading-[19px] xl:leading-[20px] 2xl:leading-[22px] font-Helvetica_Light`
                                    },
                                    {
                                        type: 'LINK',
                                        url: 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Godrej/T%26Cs/Taj+T%26Cs.pdf',
                                        content:
                                            'Taj E-voucher Terms and Conditions,',
                                        className: `inline-block lg:inline ml-1 text-primary text-[16px] xl:text-[16.5px] 2xl:text-[17px] leading-[19px] xl:leading-[20px] 2xl:leading-[22px] font-Helvetica_Light`
                                    },
                                    {
                                        type: 'LINK',
                                        url: 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Godrej/T%26Cs/Oberoi+T%26Cs.pdf',
                                        content:
                                            'Oberoi E-voucher Terms and Conditions,',
                                        className: `inline-block lg:inline ml-1 text-primary text-[16px] xl:text-[16.5px] 2xl:text-[17px] leading-[19px] xl:leading-[20px] 2xl:leading-[22px] font-Helvetica_Light`
                                    },
                                    {
                                        type: 'LINK',
                                        url: 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Godrej/T%26Cs/ITC+Hotels+T%26Cs.pdf',
                                        content:
                                            'ITC E-voucher Terms and Conditions',
                                        className: `inline-block lg:inline ml-1 text-primary text-[16px] xl:text-[16.5px] 2xl:text-[17px] leading-[19px] xl:leading-[20px] 2xl:leading-[22px] font-Helvetica_Light`
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'CUSTOM',
                        className: 'text-left w-full  py-4 ',
                        components: [
                            {
                                type: 'TEXT',
                                content:
                                    'Employee Benefits on Buying a GPL Property:',
                                className: `mt-7 tracking-wide text-black text-[17px] font-Helvetica_Medium`
                            },
                            {
                                type: 'LIST',
                                listStyle: 'list-decimal',
                                points: [
                                    'Any deviation from the below pointers would require approval from the MD & CEO',
                                    'All GPL employees who are not on probation or Notice period will be eligible for an employee benefit on buying a GPL property',
                                    'The employee benefit will be basis the number of years served with GPL with the % discount as below, the discount will be given in the cost sheet on the sales consideration'
                                ],
                                classNameContainer: ' mt-2'
                            },
                            {
                                type: 'TABLE'
                            },
                            {
                                type: 'LIST',
                                listStyle: 'list-decimal',
                                start: 4,
                                points: [
                                    'Any eligible employee can avail this benefit once in 5 years across the ongoing and upcoming projects of GPL during their tenure with the company.',
                                    'Only post the due payment completion and taking possession, the Employee can sell the property',
                                    'In any single launch project, 5% of open inventory or 25 deals whichever is less will be sanctioned for GPL Employee Benefit',
                                    'Employee discount cannot be clubbed with any other source benefit i.e., loyalty/referral benefit, corporate discount etc.',
                                    'Source must be Godrej employee for the said discount to be applicable. If an employee visits through channel partner, then they won’t be eligible for employee discount',
                                    'Employee needs to get an NOC from their respective HR to confirm their employment status, the NOC needs to be shared along with the application form',
                                    'Employee must be one of the applicants in the booking for availing the benefit',
                                    'Valid Employee ID will be required at the time of booking to avail the benefit',
                                    'No sourcing and closing credit will be given for bookings of MC, ZEC, Godrej Family, Godrej Family office. Only closing credit will be given for other employee deals',
                                    'This policy is not applicable for DM projects and certain JV projects (with legal risks) for these special projects ZSH should inform about the policy non[1]applicability in LPB',
                                    'No PLP is applicable on employee deals'
                                ],
                                classNameContainer: ' mt-2'
                            }
                        ]
                    }

                ]
            }
        ]
    },
    footer: {
        layout: 'Layout1',
        footerHeading: 'corporate office',
        footerHeadingClassName: `text-[18px] xl:text-[20px] 2xl:text-[22px] uppercase text-white font-Helvetica_Medium `,
        clientAddress:
            ' Unit No. 5C, 5th Floor, Godrej One, Pirojshanagar, Vikhroli East, Mumbai Maharashtra 400079.',
        clientAddressClassName: `text-[16px] xl:text-[16.5px] 2xl:text-[17px] leading-[19px] xl:leading-[20px] 2xl:leading-[22px] pt-3 text-white font-Helvetica_Light`,
        contactUsClassName: ` text-white  text-left pt-4 font-Helvetica_Light`,
        contactUsPath: '/contact-us',
        termsAndConditionsClassName: ` text-white pt-4 font-Helvetica_Light`,
        footerContent1:
            'This is to inform user / customer(s) that www.godrejproperties.com, www.godrejthetrees.com & www.godrej.com are the only official websites of Godrej Properties Limited (“Company”). User/Customer(s) are cautioned and advised not to rely upon any information stated on any other websites which may appear to be similar to the company’s official website, including containing company’s logo / brand name. The information contained in such websites may be misleading/false and user/customer(s) may suffer loss if they rely on such information. In the event user/customer(s) come across any such websites similar to company’s official website containing its brand name/logo or any other information, then kindly contact and inform us on partnerconnect@godrejproperties.com in order to enable the Company to take necessary action.',
        footerContent1ClassName: `text-[12px] lg:text-[12px] xl:text-[12px] leading-[18px] mt-2 text-white  font-Helvetica_Light`,
        footerContent2:
            'Please ensure that you deal with only RERA registered real estate agents (“Registered Real Estate Agents”) whose name appear as a real estate agent under the project name on the RERA web site. If you have received any unsolicited calls or text messages in breach of the regulatory norms or from agents not registered with us, please report such instances to us on partnerconnect@godrejproperties.com for our further investigation.',

        footerContent2ClassName: `text-[10px] leading-[18px] pt-4 pb-4 lg:pb-5 text-white  font-Helvetica_Light`,
        content:
            ' Reloy is run by Loyalie IT-Solutions Pvt. Ltd. This referral program is run by Loyalie IT Solutions Pvt. Ltd. and the referral payout will be processed by them. Loyalie IT Solutions Pvt. Ltd. is registered as a Real Estate Agent under RERA in Maharashtra MAHARERA NO - A51900010267 | Haryana RERA No. - HRERA-PKL-REA-239-2020 | Tamil Nadu RERA NO - TN/Agent/0092/2023 | Karnataka RERA NO-PRM/KA/RERA/1251/309/AG/180524/000935 | West Bengal RERA NO – HIRA/A/KOL/2019/000350 |Uttar Pradesh RERA NO – UPRERAAGT22593 | Gujarat RERA No: AG/GJ/AHMEDABAD/AHMEDABAD CITY/AUDA/AA01891/090327R1 | Delhi RERA Application Reference No: 22-3754-2891 | Goa RERA NO – AGGO02210817 | Telangana RERA NO – A02500001321 |maharera.mahaonline.gov.in | haryanarera.gov.in | www.tnrera.in | rera.karnataka.gov.in | http://hira.wb.gov.in | https://www.up-rera.in | https://gujrera.gujarat.gov.in | https://rera.delhi.gov.in | https://rera.goa.gov.in | http://rera.telangana.gov.in  ',
        contentClassName: `lg:pl-4 leading-[17px] text-[10px]  text-white  `
    },

    referralForm: {
        backgroundImage: godrejBgImage,
        disableInfluencerLink: true,
        bgOverlay: false,
        linearGradient: {
            degree: '90deg',
            R1: '0',
            G1: '0',
            B1: '0',
            opacity1: '0.6',
            R2: '0',
            G2: '0',
            B2: '0',
            opacity2: '0.6'
        },
        referAnyProject: false,
        userTypes: {
            length: 2,
            siteVisitor: false,
            siteVisitorHeading1: '',
            siteVisitorHeading2: '',

            bookedCustomer: true,
            bookedCustomerHeading1: '',
            bookedCustomerHeading2: '',

            employee: true,
            employeeHeading1: '',
            employeeHeading2: '',

            salesAdmin: false,
            salesAdminHeading1: 'I am a ',
            salesAdminHeading2: 'Godrej Employee*',

            influencer: false,
            influencerHeading1: '',
            influencerHeading2: ''
        },
        formContent: {
            heading: 'ENRICHING EXPERIENCES',
            headingClass: `self-center text-white sm:mt-0 text-4xl lg:text-5xl  w-[80%] lg:w-full  text-center tracking-widest  font-Helvetica_Medium`
        },
        leadEmailMandatory: false
    }
};
export default config;
